import { useState, useEffect } from 'react';
import { getScorecardInitialState } from '@/creditflowresearch/application/League/helpers';
import { IScorecardProps } from '@/creditflowresearch/application/League/Scorecard/types';
import { IScorecardState } from '@/creditflowresearch/application/League/interfaces';

export const useScorecardState = (props: IScorecardProps) => {
  const initialState = getScorecardInitialState(props);

  const [data, setData] = useState<IScorecardState['data']>(initialState.data);
  const [isFetching, setIsFetching] = useState<boolean>(initialState.isFetching);
  const [initialized, setInitialized] = useState<boolean>(initialState.initialized);
  const [expandedCategories, setExpandedCategories] = useState<string[]>(initialState.expandedCategories);
  const [columnState, setColumnState] = useState(initialState.columnState);
  const [selectedPeriod, setSelectedPeriod] = useState(initialState.selectedPeriod);
  const [companyData, setCompanyData] = useState<IScorecardState['company']['data']>(initialState.company.data);
  const [companyError, setCompanyError] = useState<string | null>(initialState.company.error);
  const [isCompanyFetching, setIsCompanyFetching] = useState<boolean>(initialState.company.isCompanyFetching);

  useEffect(() => {
    const newInitialState = getScorecardInitialState(props);
    setData(newInitialState.data);
    setIsFetching((currentIsFetching) => currentIsFetching || newInitialState.isFetching);
    setInitialized(newInitialState.initialized);
    setCompanyData(newInitialState.company.data);
    setCompanyError(newInitialState.company.error);
    setIsCompanyFetching(newInitialState.company.isCompanyFetching);
  }, [props.scorecardData, props.companyData]);

  const state: IScorecardState = {
    data,
    isFetching,
    initialized,
    expandedCategories,
    columnState,
    selectedPeriod,
    company: {
      data: companyData,
      error: companyError,
      isCompanyFetching,
    },
  };

  return {
    state,
    setData,
    setIsFetching,
    setInitialized,
    setExpandedCategories,
    setColumnState,
    setSelectedPeriod,
    setCompanyData,
    setCompanyError,
    setIsCompanyFetching,
  };
};
